import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { Language } from './language-selector';
import { TranslationService } from '../translation/translation.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { LanguageConfig } from './assets/language-config';
import { LanguageService } from './language.service';

@Component({
    selector: 'pw-languagemodule',
    templateUrl: './language.component.html',
    styleUrls: ['./language.component.scss']
})
export class LanguageComponent implements OnInit {
    displayFlag = false;

    flagImage = '';

    flagIndex = 0;

    languages: Language[] = [];

    languagesToChange: Language[] = [];

    downloadFileUrl = '';


    constructor(
        private _translateService: TranslationService,
        private _http: HttpClient,
        private _languageConfig: LanguageConfig,
        private _languageService: LanguageService,
        @Inject('DOWNLOAD_FILE_URL') private _downloadFileUrl: string
    ) {
        this.downloadFileUrl = _downloadFileUrl;
        this.flagImage = this.downloadFileUrl+'/hungaryflagicon';
    }

    ngOnInit(): void {
        this.getLanguagesAndFlags(this._languageConfig.url).subscribe({
            next: (languagesFlags) => {
                this.languages = languagesFlags;
                if(languagesFlags.length === 1) {
                    this._languageService.actualLanguage = languagesFlags[0].value.toUpperCase();


                }
            }
        });

    }

    changeLanguageMobile(language: Language) {
        void this._translateService.setLanguage(language.value);
        this.languages.forEach((value, index) => {
            if (value.value == language.value) {
                this.flagIndex = index;
                this.flagImage = value.flagImage;
                this._languageService.actualLanguage = language.value.toUpperCase();
            }
        });
        this.languagesToChange.splice(0);
        this.displayFlag = !this.displayFlag;
    }

    displayFlagSelector() {
        this.displayFlag = !this.displayFlag;
        if (this.languagesToChange.length !== 0) {
            this.languagesToChange.splice(0);
        }
        this.languages.forEach((value, index) => {
            if (index !== this.flagIndex) {
                this.languagesToChange.push(value);
            }
        });
    }

    getLanguagesAndFlags(url: string): Observable<Language[]> {
        return this._http.get<Language[]>(url);
    }
}
